/**
 * Utility to manage China detection and conditional loading
 * of third-party services blocked in China.
 *
 * Note: Detection is based on the REACT_APP_FOR_CHINA environment variable
 * set at build time in public/index.html before React loads.
 * This module provides a convenient API to access that detection.
 */

/**
 * Detect if this is a China build
 * Uses the global flag set in index.html before React loads
 * Returns true if REACT_APP_FOR_CHINA=true, false otherwise
 */
export const isUserInChina = () => {
  // Use the global flag set in index.html based on REACT_APP_FOR_CHINA env var
  // If not set, default to false (allow analytics)
  return window.__SHOULD_LOAD_ANALYTICS__ === false;
};

/**
 * Synchronous version - same as isUserInChina
 */
export const isUserInChinaSync = () => {
  return isUserInChina();
};

/**
 * Check if analytics services should be loaded
 * Returns false if user is in China
 */
export const shouldLoadAnalytics = () => {
  return !isUserInChinaSync();
};

/**
 * Check if Google services should be loaded
 * Returns false if user is in China
 */
export const shouldLoadGoogleServices = () => {
  return !isUserInChinaSync();
};

/**
 * Check if Facebook services should be loaded
 * Returns false if user is in China
 */
export const shouldLoadFacebookServices = () => {
  return !isUserInChinaSync();
};

/**
 * Check if TikTok services should be loaded
 * Returns false if user is in China
 */
export const shouldLoadTikTokServices = () => {
  return !isUserInChinaSync();
};

/**
 * Note: Since detection is now based on build-time environment variable,
 * manual overrides are no longer needed. Create separate builds for
 * China (REACT_APP_FOR_CHINA=true) and international markets.
 */
